import styled from 'styled-components';

import { Bar } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import { respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Page = styled.main<{ $plain?: boolean }>`
    flex: 1 0 auto;
    width: 100%;
    background: ${({ $plain }) => ($plain ? COLORS.pageBackground : COLORS.sectionBackground)};
`;

export const SearchFields = styled.div`
    width: 100%;
    max-width: 70rem;
    min-height: 8rem;
`;

export const Controls = styled.div`
    margin-bottom: 3.2rem;

    ${respondDown(Breakpoints.md)`margin-bottom: 2.4rem;`}
`;

export const ControlShape = styled(Bar)`
    height: 4.2rem;

    ${respondDown(Breakpoints.md)`
        height: 5.6rem;
    `}
`;
